import { render, staticRenderFns } from "./productView.vue?vue&type=template&id=39694312&"
import script from "./productView.vue?vue&type=script&lang=js&"
export * from "./productView.vue?vue&type=script&lang=js&"
import style0 from "./productView.vue?vue&type=style&index=0&id=39694312&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports